import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

interface IResponse {
  error_code: number;
  error_msg: string;
  data: any;
}
interface ISetAutoReceipt {
  status: number;
}

const SET_AUTO_RECEIPT = '/api/auto_accept_reservation/set';

@Injectable()
export class TujiaAutoReceiptService {
  constructor(private http: HttpClient) {}

  setAutoAcceptReservation(params: ISetAutoReceipt) {
    return this.http.post(SET_AUTO_RECEIPT, params) as Observable<IResponse>;
  }
}
